(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq-browser"] && !Shopify.designMode) return;
  try {
    
(function () {
  function normalize(value) {
    return (value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function filter(root) {
    var input = root.querySelector('[data-pk-faq-input]');
    var query = normalize(input ? input.value : '');
    var active = query ? '' : root.getAttribute('data-active-category') || '';
    var shown = 0;

    root.querySelectorAll('[data-pk-faq-group]').forEach(function (group) {
      var categoryMatch = active === '' || group.getAttribute('data-category') === active;
      var groupShown = 0;
      group.querySelectorAll('[data-pk-faq-item]').forEach(function (item) {
        var match = categoryMatch && (query === '' || normalize(item.textContent).indexOf(query) !== -1);
        item.hidden = !match;
        if (match) groupShown += 1;
      });
      group.hidden = groupShown === 0;
      shown += groupShown;
    });

    var empty = root.querySelector('[data-pk-faq-empty]');
    if (empty) empty.hidden = shown !== 0;

    var status = root.querySelector('[data-pk-faq-status]');
    if (status) status.textContent = shown + ' ' + (root.getAttribute('data-results-label') || '');

    root.querySelectorAll('[data-pk-faq-chip]').forEach(function (chip) {
      var pressed = query === '' && chip.getAttribute('data-category') === active;
      chip.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    });
  }

  function init(root) {
    if (!root || root.getAttribute('data-pk-faq-ready') === 'true') return;
    root.setAttribute('data-pk-faq-ready', 'true');
    var first = root.querySelector('[data-pk-faq-chip]');
    if (first && !root.getAttribute('data-active-category')) {
      root.setAttribute('data-active-category', first.getAttribute('data-category'));
    }
    filter(root);
  }

  function boot() {
    document.querySelectorAll('[data-pk-faq]').forEach(init);
  }

  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-pk-faq-input]');
    if (!input) return;
    var root = input.closest('[data-pk-faq]');
    if (root) filter(root);
  });

  document.addEventListener('click', function (event) {
    var chip = event.target.closest('[data-pk-faq-chip]');
    if (!chip) return;
    var root = chip.closest('[data-pk-faq]');
    if (!root) return;
    var input = root.querySelector('[data-pk-faq-input]');
    if (input) input.value = '';
    root.setAttribute('data-active-category', chip.getAttribute('data-category'));
    filter(root);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-pk-faq]');
    if (!root) return;
    root.removeAttribute('data-pk-faq-ready');
    init(root);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-gift-card-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function readConfig(root) {
      var node = root.querySelector('[data-cgift-config]');
      if (!node) return {};
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return {};
      }
    }

    function plainText(value) {
      var holder = document.createElement('div');
      holder.innerHTML = value || '';
      return holder.textContent || '';
    }

    function isoDate(date) {
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      return date.getFullYear() + '-' + month + '-' + day;
    }

    function selectedChoice(root) {
      return root.querySelector('[data-cgift-choice]:checked');
    }

    function syncVariant(root) {
      var choice = selectedChoice(root);
      var preview = root.querySelector('[data-cgift-preview]');
      root.querySelectorAll('[data-cgift-variant]').forEach(function (input) {
        input.value = choice && choice.value ? choice.value : '';
      });
      var selection = root.querySelector('[data-cgift-selection]');
      var selectionAmount = selection ? selection.querySelector('[data-cgift-selection-amount]') : null;
      if (selection) selection.hidden = !(choice && choice.value);
      if (selectionAmount && choice && choice.dataset.amount) selectionAmount.textContent = choice.dataset.amount;
      if (choice && preview) {
        if (choice.dataset.src) {
          preview.removeAttribute('srcset');
          preview.src = choice.dataset.src;
        }
        if (choice.dataset.alt) preview.alt = choice.dataset.alt;
      }
      return choice;
    }

    function setFieldError(input, message) {
      if (!input) return;
      var field = input.closest('[data-cgift-field]');
      var error = field ? field.querySelector('[data-cgift-error]') : null;
      if (message) {
        input.setAttribute('aria-invalid', 'true');
        if (error) {
          error.hidden = false;
          error.textContent = message;
        }
      } else {
        input.removeAttribute('aria-invalid');
        if (error) {
          error.hidden = true;
          error.textContent = '';
        }
      }
    }

    function showPageError(root, message) {
      var node = root.querySelector('[data-cgift-page-error]');
      if (!node) return;
      if (message) {
        node.hidden = false;
        node.textContent = message;
      } else {
        node.hidden = true;
        node.textContent = '';
      }
    }

    function showAlert(form, message) {
      var node = form.querySelector('[data-cgift-alert]');
      if (!node) return;
      if (message) {
        node.hidden = false;
        node.textContent = message;
      } else {
        node.hidden = true;
        node.textContent = '';
      }
    }

    function setBusy(button, config, busy) {
      if (!button) return;
      if (busy) {
        if (!button.dataset.label) button.dataset.label = button.textContent;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = config.sending || button.dataset.label;
      } else {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (button.dataset.label) button.textContent = button.dataset.label;
      }
    }

    async function addToCart(root, form, button) {
      var config = readConfig(root);
      var choice = syncVariant(root);
      if (!choice || !choice.value) {
        showPageError(root, config.errorSelect);
        return;
      }
      showPageError(root, '');
      showAlert(form, '');
      var offset = form.querySelector('[data-cgift-offset]');
      if (offset) offset.value = String(new Date().getTimezoneOffset());
      setBusy(button, config, true);
      try {
        var endpoint = config.cartAddUrl || '/cart/add';
        if (endpoint.indexOf('.js') === -1) endpoint += '.js';
        var response = await fetch(endpoint, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        var data = await response.json();
        if (!response.ok) {
          showAlert(form, plainText(data.description || data.message) || config.errorCart);
          setBusy(button, config, false);
          return;
        }
        window.location.assign(config.checkoutUrl || '/checkout');
      } catch (error) {
        showAlert(form, config.errorCart);
        setBusy(button, config, false);
      }
    }

    function validateGift(root, form, requireDate) {
      var config = readConfig(root);
      var name = form.querySelector('[data-cgift-name]');
      var email = form.querySelector('[data-cgift-email]');
      var greeting = form.querySelector('[data-cgift-greeting]');
      var sendOn = form.querySelector('[data-cgift-send-on]');
      var valid = true;
      var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      setFieldError(name, '');
      setFieldError(email, '');
      setFieldError(greeting, '');
      setFieldError(sendOn, '');
      showAlert(form, '');

      if (!name || !name.value.trim()) {
        setFieldError(name, config.errorName);
        valid = false;
      } else if (name.value.trim().length > 255) {
        setFieldError(name, config.errorName);
        valid = false;
      }

      if (!email || !emailPattern.test(email.value.trim())) {
        setFieldError(email, config.errorEmail);
        valid = false;
      }

      if (greeting && greeting.value.length > 200) {
        setFieldError(greeting, config.errorGreeting);
        valid = false;
      }

      if (requireDate) {
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        var max = new Date(today);
        max.setDate(max.getDate() + 90);
        var chosen = sendOn && sendOn.value ? new Date(sendOn.value + 'T00:00:00') : null;
        if (!sendOn || !sendOn.value) {
          setFieldError(sendOn, config.errorDate);
          valid = false;
        } else if (chosen < today) {
          setFieldError(sendOn, config.errorFuture);
          valid = false;
        } else if (chosen > max) {
          setFieldError(sendOn, config.errorRange);
          valid = false;
        }
      }

      if (!valid) {
        var invalid = form.querySelector('[aria-invalid="true"]');
        if (invalid) invalid.focus();
      }
      return valid;
    }

    function init(root) {
      if (!root || root.dataset.cgiftReady === 'true') return;
      root.dataset.cgiftReady = 'true';
      var config = readConfig(root);
      var buyForm = root.querySelector('form.cgift-buy');
      var giftForm = root.querySelector('form.cgift-gift');
      var dialog = root.querySelector('[data-cgift-dialog]');
      var openButton = root.querySelector('[data-cgift-open]');
      var closeButton = root.querySelector('[data-cgift-close]');
      var scheduleButton = root.querySelector('[data-cgift-schedule-btn]');
      var schedulePanel = root.querySelector('[data-cgift-schedule]');
      var sendOn = root.querySelector('[data-cgift-send-on]');
      var sendButton = root.querySelector('[data-cgift-send]');

      var occasionTag = root.querySelector('[data-cgift-occasion-tag]');
      root.querySelectorAll('[data-cgift-occasion]').forEach(function (input) {
        input.addEventListener('change', function () {
          if (!occasionTag || !input.checked) return;
          occasionTag.textContent = input.value;
          occasionTag.hidden = false;
        });
      });

      if (sendOn) {
        var today = new Date();
        var max = new Date();
        max.setDate(max.getDate() + 90);
        sendOn.min = isoDate(today);
        sendOn.max = isoDate(max);
      }

      root.addEventListener('change', function (event) {
        if (event.target.matches('[data-cgift-choice]')) syncVariant(root);
      });

      if (buyForm) {
        buyForm.addEventListener('submit', function (event) {
          event.preventDefault();
          var button = buyForm.querySelector('[data-intent="self"]');
          var choice = syncVariant(root);
          if (!choice || !choice.value) {
            showPageError(root, config.errorSelect);
            return;
          }
          addToCart(root, buyForm, button);
        });
      }

      if (openButton && dialog) {
        openButton.addEventListener('click', function () {
          var choice = syncVariant(root);
          if (!choice || !choice.value) {
            showPageError(root, config.errorSelect);
            return;
          }
          showPageError(root, '');
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
          var name = giftForm && giftForm.querySelector('[data-cgift-name]');
          if (name) name.focus();
        });
      }

      function closeDialog() {
        if (!dialog) return;
        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        else dialog.removeAttribute('open');
        if (openButton) openButton.focus();
      }

      if (closeButton) closeButton.addEventListener('click', closeDialog);

      if (dialog) {
        dialog.addEventListener('click', function (event) {
          var rect = dialog.getBoundingClientRect();
          var inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
          if (!inside) closeDialog();
        });
        dialog.addEventListener('close', function () {
          if (openButton) openButton.focus();
        });
      }

      if (scheduleButton && schedulePanel && sendOn && giftForm) {
        scheduleButton.addEventListener('click', function () {
          var opening = schedulePanel.hasAttribute('hidden');
          if (opening) {
            schedulePanel.hidden = false;
            sendOn.disabled = false;
            scheduleButton.setAttribute('aria-expanded', 'true');
            sendOn.focus();
            return;
          }
          if (!validateGift(root, giftForm, true)) return;
          addToCart(root, giftForm, scheduleButton);
        });
      }

      if (giftForm) {
        giftForm.addEventListener('submit', function (event) {
          event.preventDefault();
          if (sendOn) sendOn.disabled = true;
          if (!validateGift(root, giftForm, false)) {
            if (schedulePanel && !schedulePanel.hasAttribute('hidden') && sendOn) sendOn.disabled = false;
            return;
          }
          addToCart(root, giftForm, sendButton);
        });
      }
    }

    function boot() {
      document.querySelectorAll('[data-cgift-grid]').forEach(init);
    }

    boot();
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-cgift-grid]');
      if (event.target.matches && event.target.matches('[data-cgift-grid]')) root = event.target;
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pk-listing-catalog"] && !Shopify.designMode) return;
  try {
    
(function () {
  function openPkCart(cart) {
    if (window.wetheme && typeof window.wetheme.toggleRightDrawer === 'function') {
      window.wetheme.toggleRightDrawer('cart', true, cart ? { cart: cart } : {});
      return;
    }
    var drawer = document.querySelector('[aria-controls="CartDrawer"]');
    if (drawer) drawer.click();
  }
  window.openPkCart = openPkCart;

  document.addEventListener('click', function (event) {
    var bag = event.target.closest && event.target.closest('[data-pk-cart]');
    if (!bag) return;
    event.preventDefault();
    openPkCart();
  }, true);

  var root = document.querySelector('[data-pk-catalog]');
  if (!root || root.dataset.bound === 'true') return;
  root.dataset.bound = 'true';

  var cart = null;
  var busy = {};

  function formatMoney(cents) {
    var fmt = root.dataset.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var amount = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      if (key === 'amount_no_decimals') return amount.split('.')[0];
      if (key === 'amount_with_comma_separator') return amount.replace(/,/g, '.').replace(/\.(\d{2})$/, ',$1');
      return amount;
    });
  }

  function request(url, body) {
    var options = { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } };
    if (body) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    return fetch(url, options).then(function (response) {
      if (!response.ok) throw new Error('cart');
      return response.json();
    });
  }

  function fetchCart() {
    return request('/cart.js').then(function (data) { cart = data; return data; });
  }

  function qtyOf(variantId) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (sum, item) {
      return String(item.variant_id) === String(variantId) ? sum + item.quantity : sum;
    }, 0);
  }

  // Cards keep the "Added" stepper for anything already in the cart, also after a reload.
  function render() {
    root.querySelectorAll('.pk-card__form[data-pk-variant]').forEach(function (form) {
      var id = form.dataset.pkVariant;
      if (!form.querySelector('.pk-card__added')) return;
      var qty = qtyOf(id);
      form.dataset.state = qty > 0 ? 'added' : 'add';
      form.classList.toggle('is-busy', !!busy[id]);
      var qtyNode = form.querySelector('[data-pk-qty]');
      if (qtyNode) qtyNode.textContent = String(qty);
      var total = form.querySelector('[data-pk-line-total]');
      if (total) total.textContent = qty > 0 ? formatMoney(Number(form.dataset.pkPrice || 0) * qty) : '';
    });
    if (cart) {
      // The page nav's bag (when enabled) and the site header's cart count.
      document.querySelectorAll('[data-pk-cart-count], .cart-item-count-header--quantity').forEach(function (node) {
        node.textContent = String(cart.item_count);
      });
      document.querySelectorAll('.site-header__cart-indicator').forEach(function (node) {
        node.classList.toggle('hide', !cart.item_count);
      });
    }
  }

  function showError(form) {
    var status = form.querySelector('.pk-card__status');
    if (status) status.textContent = root.dataset.error || '';
  }

  function run(form, op, openDrawer) {
    var id = form.dataset.pkVariant;
    if (busy[id]) return;
    busy[id] = true;
    var status = form.querySelector('.pk-card__status');
    if (status) status.textContent = '';
    render();
    op().then(fetchCart).then(function () {
      if (status) status.textContent = root.dataset.added || '';
      if (openDrawer) openPkCart(cart);
    }).catch(function () {
      showError(form);
      return fetchCart().catch(function () {});
    }).finally(function () {
      busy[id] = false;
      render();
    });
  }

  function add(form, openDrawer) {
    run(form, function () {
      return request('/cart/add.js', { id: Number(form.dataset.pkVariant), quantity: 1 });
    }, openDrawer);
  }

  function decrease(form) {
    var id = form.dataset.pkVariant;
    run(form, function () {
      var lines = (cart && cart.items) ? cart.items.filter(function (item) { return String(item.variant_id) === String(id); }) : [];
      var line = lines[lines.length - 1];
      if (!line) return Promise.resolve();
      return request('/cart/change.js', { id: line.key, quantity: line.quantity - 1 });
    }, false);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('pk-card__form')) return;
    event.preventDefault();
    event.stopPropagation();
    var button = form.querySelector('[type="submit"]');
    if (!button || button.disabled || !form.dataset.pkVariant) return;
    add(form, true);
  }, true);

  root.addEventListener('click', function (event) {
    var inc = event.target.closest('[data-pk-inc]');
    var dec = event.target.closest('[data-pk-dec]');
    if (!inc && !dec) return;
    var form = (inc || dec).closest('.pk-card__form');
    if (!form) return;
    event.preventDefault();
    if (inc) add(form, false);
    else decrease(form);
  });

  // The cart drawer fires this after its own quantity changes.
  document.documentElement.addEventListener('wetheme-cart-update', function (event) {
    var data = event && event.detail && event.detail.cart;
    if (data && data.items) { cart = data; render(); }
    else fetchCart().then(render).catch(function () {});
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) fetchCart().then(render).catch(function () {});
  });

  fetchCart().then(render).catch(function () {});
})();

  } catch(e) { console.error(e); }
})();
})();
